import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("trustline_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fileUrl = (id) => `${API}/files/${id}`;

export function formatError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const PARTIAL_SERVICE = "Custom / Partial Cleaning";
export const PARTIAL_TASKS = [
  { key: "kitchen", minutes: 90 },
  { key: "bathroom", minutes: 60, multi: true },
  { key: "toilet", minutes: 20 },
  { key: "living_room", minutes: 45 },
  { key: "bedroom", minutes: 30, multi: true },
];

export const SERVICES = [
  "Regular Cleaning",
  PARTIAL_SERVICE,
  "Deep Cleaning",
  "Move-In / Move-Out Cleaning",
  "Post-Construction Cleaning",
  "Office / Commercial Cleaning",
  "Airbnb Cleaning",
  "Window Cleaning",
  "Garden / Terrace Cleaning",
  "Pressure Washing",
];

// Services that support optional add-ons (per spec: Regular/Maintenance + Deep only)
export const ADDONS_SERVICES = ["Regular Cleaning", "Deep Cleaning", "Move-In / Move-Out Cleaning", PARTIAL_SERVICE, "Airbnb Cleaning", "Post-Construction Cleaning"];
// Services that support recurring frequency
export const RECURRING_SERVICES = ["Regular Cleaning", "Office / Commercial Cleaning", "Airbnb Cleaning", "Deep Cleaning"];
export const ADDONS = [
  { key: "inside_fridge", label: "Refrigerator Cleaning", minutes: 30 },
  { key: "inside_oven", label: "Oven Cleaning", minutes: 20 },
  { key: "inside_cabinets", label: "Inside Cabinets", minutes: 30 },
  { key: "radiator", label: "Radiator", minutes: 30 },
  { key: "interior_windows", label: "Interior Windows", minutes: 45 },
  { key: "exterior_windows", label: "Exterior Windows", minutes: 60, note: "+€40 flat" },
  { key: "balcony_patio", label: "Balcony / Patio", minutes: 120 },
];

// Services limited to specific add-ons; others offer every add-on
export const ADDONS_BY_SERVICE = { "Move-In / Move-Out Cleaning": ["balcony_patio"] };
export const addonsFor = (service) => {
  const only = ADDONS_BY_SERVICE[service];
  return only ? ADDONS.filter((a) => only.includes(a.key)) : ADDONS;
};

export const CUSTOM_QUOTE_SERVICES = ["Office / Commercial Cleaning", "Window Cleaning", "Garden / Terrace Cleaning", "Pressure Washing"];

export const CLIENT_TYPES = ["Residential / Private", "Commercial / B2B"];

export const CUSTOMER_PAYMENT_STATUSES = [
  "Not Sent", "Invoice Sent", "Deposit Paid", "Paid", "Partially Paid", "Overdue", "Refunded", "Cancelled",
];
export const PAYOUT_STATUSES = [
  "Not Ready", "Customer Unpaid", "Ready for Review", "Ready to Pay", "Paid", "On Hold", "Disputed",
];

export const LEAD_STATUSES = [
  "New Lead", "Contacted", "Quoted", "Awaiting Customer Confirmation", "Confirmed", "Lost", "Cancelled"
];

export const JOB_STATUSES = [
  "New Request", "Quoted", "Awaiting Customer Confirmation", "Confirmed",
  "Cleaner Assigned", "In Progress", "Completed", "Cancelled",
  "Payment Pending", "Complaint / Re-clean", "Follow-Up Needed"
];

export const PAYMENT_STATUSES = [
  "Not Sent", "Invoice Sent", "Deposit Paid", "Paid", "Partially Paid", "Overdue", "Refunded"
];

export const COMPLAINT_STATUSES = [
  "New Complaint", "Under Review", "Re-clean Offered", "Re-clean Scheduled", "Resolved", "Closed"
];

export const CITIES = ["Amsterdam", "Rotterdam", "Utrecht", "The Hague", "Eindhoven", "Haarlem", "Delft", "Amersfoort"];

export const WHATSAPP_NUMBER = "+31642449019";
export const whatsappLink = (msg = "Hi Trustline, I'd like to request a cleaning quote.") =>
  `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`;
